import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";

/**
 * Composable for contact deletion mutations
 */
export function useDeleteContact() {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: async (contactIds: string | string[]) => {
      const ids = Array.isArray(contactIds) ? contactIds.join(",") : contactIds;
      const result = await Contact.deleteContact(ids);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete contact(s)");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
    },
  });

  return {
    deleteContact: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
    deleteError: deleteMutation.error,
  };
}
